const forPreferenceCenterSmsCheckbox = require("./forPreferenceCenterSmsCheckbox");

/**
 * @param preferenceCenter {HTMLElement}
 * @param onChange {(checked: boolean) => void}
 * @return {void}
 */
module.exports = function listenToPreferenceCenterSmsSwitchChange(preferenceCenter, onChange) {
    forPreferenceCenterSmsCheckbox(preferenceCenter, input => {
        input.addEventListener("change", () => {
            onChange(input.checked);
        });
    });
}
